import React, { PureComponent } from 'react';
import transform from '../transform';
import defaultSettings from './settings';
import {
    canUpdateEssentialsV2,
    isActiveForAU,
    loadCrazyEgg,
    trackAnalyticsEventAU,
} from '../utils';
import userSettings from '../pricing/userSettings';
import {
    GA_CHANGE_PLAN_CATEGORY,
    GA_CHOOSE_PACKAGE,
    GA_CONTACT_CHANGE_PLAN_VIEW,
    GA_DOWNGRADE_CHANGE_PLAN_VIEW,
    GA_NOTIFICATION_BANNER_VIEWED,
    GA_P1_LABEL,
    GA_P2_LABEL,
    GA_P3_LABEL,
    GA_PACKAGE_VIEWED,
    GA_UPGRADE_CHANGE_PLAN_VIEW,
    PRICING_PACKAGE_CTA_ACTION,
} from '../../constants/analytics';
import {
    ESSENTIAL_V2_UPDATE_URL,
    LOCALE_WITH_VERSION_2,
    PACKAGE_ONE,
    PACKAGE_TWO,
    PRICING_PAGE,
} from '../../constants/main';
import {
    UPDATE_BANNER_CTA,
    UPDATE_BANNER_HEADING,
} from '../../constants/update';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import PackageUpdateBanner from '../../components/PackageUpdateBanner';
import Packages from '../../components/Packages';
import { generateAdditionalSettings } from './additionalSettings';

export default class ChangePlanPage extends PureComponent {
    componentDidMount() {
        const { trackEvent, userPlan } = this.props;

        if (userPlan === PACKAGE_ONE) {
            trackEvent({
                action: GA_UPGRADE_CHANGE_PLAN_VIEW,
                label: GA_P1_LABEL,
                category: GA_CHANGE_PLAN_CATEGORY,
            });
            trackEvent({
                action: GA_CONTACT_CHANGE_PLAN_VIEW,
                label: GA_P1_LABEL,
                category: GA_CHANGE_PLAN_CATEGORY,
            });
        } else if (userPlan === PACKAGE_TWO) {
            trackEvent({
                action: GA_DOWNGRADE_CHANGE_PLAN_VIEW,
                label: GA_P2_LABEL,
                category: GA_CHANGE_PLAN_CATEGORY,
            });
            trackEvent({
                action: GA_CONTACT_CHANGE_PLAN_VIEW,
                label: GA_P2_LABEL,
                category: GA_CHANGE_PLAN_CATEGORY,
            });
        }

        this._trackEventActionsAU(GA_PACKAGE_VIEWED);

        //Crazy Egg
        loadCrazyEgg();
    }

    _trackEventActionsAU(action) {
        const {
            assortmentsAvailability,
            launchPackageEssentialV2,
            locale,
            userId,
            userPlan,
        } = this.props;
        const version = assortmentsAvailability
            ? assortmentsAvailability.current.version
            : null;
        if (isActiveForAU({ locale, launchPackageEssentialV2 })) {
            trackAnalyticsEventAU({
                action: action,
                category: GA_CHOOSE_PACKAGE,
                dimensions: {
                    userId,
                    userPlan,
                    version,
                    locale,
                },
            });
        }
    }

    componentWillUnmount() {
        const { hideMainNotification } = this.props;
        hideMainNotification();
    }

    generateCTAActions() {
        const {
            locale,
            goToDowngrade,
            contactUsRedirect,
            goToUpdateVersionTwo,
            setPackageTwo,
            assortmentsAvailability,
            launchPackageEssentialV2,
            trackEvent,
        } = this.props;

        if (
            launchPackageEssentialV2 &&
            assortmentsAvailability &&
            canUpdateEssentialsV2({ locale, assortmentsAvailability })
        ) {
            return [
                goToUpdateVersionTwo.bind(
                    null,
                    PRICING_PACKAGE_CTA_ACTION,
                    GA_P1_LABEL,
                ),
                setPackageTwo.bind(
                    null,
                    PRICING_PACKAGE_CTA_ACTION,
                    GA_P2_LABEL,
                ),
                contactUsRedirect.bind(
                    null,
                    PRICING_PACKAGE_CTA_ACTION,
                    GA_P3_LABEL,
                ),
            ];
        }

        return [
            goToDowngrade.bind(null, PRICING_PACKAGE_CTA_ACTION, GA_P1_LABEL),
            setPackageTwo.bind(null, PRICING_PACKAGE_CTA_ACTION, GA_P2_LABEL),
            contactUsRedirect.bind(
                null,
                PRICING_PACKAGE_CTA_ACTION,
                GA_P3_LABEL,
            ),
        ];
    }

    render() {
        const {
            locale,
            isAuthenticated,
            addMainNotification,
            assortmentsPricing,
            assortmentsTax,
            goToDowngrade,
            contactUsRedirect,
            hasFixedFee,
            userPlan,
            setPackageOneVersionTwo,
            setPackageTwo,
            assortmentsAvailability,
            launchPackageEssentialV2,
            goToOverviewPage,
        } = this.props;

        const additionalSettings = generateAdditionalSettings({
            locale,
            isAuthenticated,
            assortmentsAvailability,
            launchPackageEssentialV2,
        });
        const { breadcrumbs, packagesList } = transform({
            locale,
            isAuthenticated,
            userPlan,
            defaultSettings,
            userSettings,
            page: PRICING_PAGE,
            additionalSettings,
        });
        const learnMoreActions = Array(3).fill(goToOverviewPage);

        // Hide Learn More component if locale includes Essentials new version
        const shouldShowLearnMore = !(
            LOCALE_WITH_VERSION_2.includes(locale) && launchPackageEssentialV2
        );

        if (canUpdateEssentialsV2({ locale, assortmentsAvailability })) {
            const updatePlanContent = (
                <PackageUpdateBanner
                    heading={UPDATE_BANNER_HEADING}
                    bannerCTA={UPDATE_BANNER_CTA}
                    redirectUrl={ESSENTIAL_V2_UPDATE_URL}
                />
            );
            addMainNotification({
                children: updatePlanContent,
                hasCloseButton: true,
                shouldPersist: true,
                isNotificationSticky: true,
            });

            this._trackEventActionsAU(GA_NOTIFICATION_BANNER_VIEWED);
        }

        return (
            <div className="eds-g-grid eds-bg-color--grey-100">
                <HeaderBreadcrumbs {...breadcrumbs} />
                <div className="eds-l-pad-bot-10">
                    <Packages
                        {...packagesList}
                        pricing={assortmentsPricing}
                        taxLabel={assortmentsTax}
                        hasFixedFee={hasFixedFee}
                        CTAActions={this.generateCTAActions()}
                        shouldShowLearnMore={shouldShowLearnMore}
                        shouldShowNewTag={isActiveForAU({
                            locale,
                            launchPackageEssentialV2,
                        })}
                        learnMoreActions={learnMoreActions}
                        fixedHeight={true}
                    />
                </div>
            </div>
        );
    }
}
